const CheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.02728 8C3.22693 8 3.3848 7.91104 3.49623 7.73784L7.88391 0.77238C7.96751 0.636629 8 0.533646 8 0.425981C8 0.168518 7.83284 0 7.57748 0C7.39174 0 7.2896 0.0608544 7.17818 0.238738L3.00871 6.93737L0.845037 4.08192C0.72896 3.91806 0.612887 3.85255 0.445734 3.85255C0.181079 3.85255 0 4.0351 0 4.29255C0 4.40024 0.0464309 4.52196 0.134649 4.63428L2.5444 7.72849C2.68369 7.91104 2.82763 8 3.02728 8Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckIcon;
